import React, { Fragment } from "react";

import { ProductVisibilityTypes } from "@utils/enums";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import {
    ProductVariant,
    ProductVariants,
} from "lib/@types/service/product/shared";

import DropdownFallback from "./dropdownFallback/dropdownFallback.component";
import Swatches from "./swatches/swatches.component";

type Props = {
    variantGroups: ProductVariants;
    layout?: string;
    sku: string;
};

const Variant = ({ variantGroups, sku }: Props) => {
    const { t } = useGranite();
    const variantTypes = Object.keys(variantGroups).filter(
        variantType =>
            variantGroups[variantType].filter(
                variant =>
                    variant.productVisibilityType !==
                    ProductVisibilityTypes.NotAvailable,
            ).length > 1,
    );

    const hasMissingSwatches = (variantGroup: Array<ProductVariant>) => {
        return (
            variantGroup
                .filter(
                    variant =>
                        variant.productVisibilityType !==
                        ProductVisibilityTypes.NotAvailable,
                )
                .filter(
                    variant =>
                        variant.thumbnailUrl === undefined ||
                        variant.thumbnailUrl === null,
                ).length > 0
        );
    };

    if (!variantTypes.length) {
        return <Fragment />;
    }

    return (
        <Fragment>
            {variantTypes.map(variantType => {
                return (
                    <div
                        key={variantType}
                        className="d-flex flex-column p-0 mb-3"
                    >
                        <p className="w-100 mb-2">
                            {t("ecommerce.text.variantSelect")}{" "}
                            {variantType?.toLowerCase()}
                        </p>

                        <div className="d-flex flex-row flex-wrap">
                            {hasMissingSwatches(variantGroups[variantType]) ? (
                                <DropdownFallback
                                    sku={sku}
                                    variantGroup={variantGroups[variantType]}
                                />
                            ) : (
                                <Swatches
                                    sku={sku}
                                    variantGroup={variantGroups[variantType]}
                                />
                            )}
                        </div>
                    </div>
                );
            })}
        </Fragment>
    );
};

export default Variant;
